import React from 'react';


const tecno = [
    { T: 'Wordpress', L: 'https://wordpress.org/' },
    { T: 'HTML', L: 'https://www.w3schools.com/html/' },
    { T: 'CSS', L: 'https://www.w3schools.com/css/' },

];


class Pizza extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>PizzaHot</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <iframe src="https://www.youtube.com/embed/26EvtLvc7aw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>Local server WordPress website for pizzeria based on pizza hat with custom template.</p>

                        <a href="https://github.com/BrandonGrimaldoM/PIZZAHOTWP" target="_blank" rel="noreferrer">
                        <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>



                </div>


            </React.Fragment>
        );
    }
}

export default Pizza;